import React from "react";

/**
 * BrandMark — small green diamond + LuxTender wordmark + brand subtitle.
 * Sized for the 56px top nav.
 */
export default function BrandMark({ brand = "Lux Construction" }) {
  return (
    <div className="flex items-center gap-2.5 select-none">
      {/* Diamond */}
      <span
        aria-hidden="true"
        className="inline-block bg-accent"
        style={{
          width: 9,
          height: 9,
          transform: "rotate(45deg)",
          borderRadius: 1.5,
          boxShadow: "0 0 0 2px rgba(47,79,62,0.08)"
        }}
      />
      <div className="flex items-baseline gap-2 leading-none">
        <span
          className="font-display text-ink"
          style={{ fontWeight: 600, fontSize: 17, letterSpacing: "-0.005em" }}
        >
          LuxTender
        </span>
        <span
          className="text-ink-3"
          style={{ fontSize: 11, fontWeight: 500, letterSpacing: "0.02em" }}
        >
          · {brand}
        </span>
      </div>
    </div>
  );
}
